var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProfileActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 7",
    clipPath: "url(#clip0_4109_1737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3998 4.42773C10.0918 4.42773 8.21387 6.30548 8.21387 8.61371C8.21387 10.9218 10.0918 12.7995 12.3998 12.7995C14.7079 12.7995 16.5858 10.9218 16.5858 8.61371C16.5858 6.30548 14.7079 4.42773 12.3998 4.42773Z",
    fill: "url(#paint0_linear_4109_1737)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.3999 0C5.78302 0 0.399902 5.38312 0.399902 12C0.399902 15.0615 1.55292 17.8583 3.44659 19.9807C3.85217 18.1998 4.7829 16.5749 6.14191 15.3091C7.0957 14.4207 8.21173 13.7558 9.41803 13.3423C7.85065 12.3505 6.80768 10.6016 6.80768 8.61365C6.80768 5.52997 9.31641 3.02142 12.3999 3.02142C15.4834 3.02142 17.9919 5.52997 17.9919 8.61365C17.9919 10.6007 16.9499 12.349 15.3836 13.3411C16.6902 13.7886 17.8879 14.5316 18.8934 15.537C20.1218 16.7655 20.97 18.3096 21.3523 19.9814C23.2467 17.859 24.3999 15.0619 24.3999 12C24.3999 5.38312 19.0168 0 12.3999 0Z",
    fill: "url(#paint1_linear_4109_1737)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.67041 21.1708C6.76001 22.9349 9.4577 23.9998 12.4 23.9998C15.3423 23.9998 18.04 22.9347 20.1296 21.1708C19.9372 19.4225 19.1515 17.7836 17.8992 16.5313C16.43 15.0621 14.477 14.2529 12.4 14.2529C8.44421 14.2529 5.09979 17.2707 4.67041 21.1708Z",
    fill: "url(#paint2_linear_4109_1737)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4109_1737",
    x1: 12.3998,
    y1: 4.42773,
    x2: 12.3998,
    y2: 12.7995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F00F11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CC0D0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4109_1737",
    x1: 12.3999,
    y1: -5.95492e-7,
    x2: 12.3999,
    y2: 19.9814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F00F11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CC0D0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4109_1737",
    x1: 12.4,
    y1: 14.2529,
    x2: 12.4,
    y2: 23.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F00F11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CC0D0E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4109_1737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.399902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileActive);
export default __webpack_public_path__ + "static/media/icon_profile_active.950f43cb329a6f96a1e13522836b9402.svg";
export { ForwardRef as ReactComponent };